export const API_BASE_URL = process.env.API_BASE_URL ?? '';

export const SUB_PAYLINK_URL = `${process.env.SUB_PAYLINK_URL ?? ''}`;

export const PG_INGESTION_URL = `${process.env.PG_INGESTION_URL ?? ''}`;

export const ApiPath = {
	GET_PAYLINK_DETAIL: `${SUB_PAYLINK_URL}/paylinks/ui/v1/status`,
	THEME_CONFIG: `${SUB_PAYLINK_URL}/checkout/ui/v2/config/STANDARD_CHECKOUT_UI_CONFIG`,
	VERIFY_CUSTOMER: `${SUB_PAYLINK_URL}/paylinks/ui/v1/customer-details`,
	EVENT_INGESTION: `${PG_INGESTION_URL}/events/batch`,
};
